import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://diccionario-apple.impultienda.ar/checkout';
type CTAButtonProps = {
  label?: string;
  note?: string;
  className?: string;
  /** When true, the button goes straight to the checkout. Otherwise it scrolls to the offer section. */
  checkout?: boolean;
};
export function CTAButton({
  label = 'QUIERO DOMINAR MI IPHONE AHORA',
  note,
  className = '',
  checkout = false
}: CTAButtonProps) {
  const linkProps = checkout ? {
    href: CHECKOUT_URL,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {
    href: '#comprar'
  };
  return <div className={`flex flex-col items-center gap-3 ${className}`} data-id="element-79" data-mp="33nup9ws7g0fk">
      <a {...linkProps} className="group inline-flex w-full max-w-xl items-center justify-center gap-3 rounded-full bg-accent px-8 py-5 text-center text-sm font-bold uppercase tracking-wide text-white shadow-[0_10px_40px_-12px_rgba(10,132,255,0.9)] transition-transform duration-200 hover:-translate-y-0.5 hover:bg-accent-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink-950 sm:text-base" data-id="element-80" data-mp="2ypjg7o9qhtye">
        {label}
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-81" data-mp="1i9umbl0njdk0" />
      </a>
      {note ? <p className="text-xs text-white/45 sm:text-sm" data-id="element-82" data-mp="1na8x3atn11lq">{note}</p> : null}
    </div>;
}